import { initLightbox } from './lightbox';
import { initVideoFacades } from './videoFacade';
import { initContactForm } from './contactForm';

initLightbox();
initVideoFacades();
initContactForm();
